import { toastGenerate } from '@_shared/libs';

export function folderToast() {
	function duplicatedFolderName() {
		toastGenerate({
			message: '이미 사용 중인 폴더명입니다.',
		});
	}

	function maxFolderCount() {
		toastGenerate({
			message: '폴더는 최대 30개까지만 추가할 수 있어요!',
		});
	}

	function minFolderCount() {
		toastGenerate({
			message: '마지막 폴더는 삭제할 수 없어요!',
		});
	}

	return {
		duplicatedFolderName,
		maxFolderCount,
		minFolderCount,
	};
}
